import { BigBlueArrowLeft, FilterViewModel, Loader, MeetingViewModel, PageWrapper } from '@components';
import { IMeeting, PageRoutes, shortMonths, useViewModel, weekDaysShort } from '@utils';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/views/filteredMeetingsPage/filteredMeetingsPage.scss';
import { CalendarViewModel } from '../calendarPage';

export const FilteredMeetingsPage: FC = observer(() => {
  const calendarViewModel = useViewModel(CalendarViewModel);
  const filterViewModel = useViewModel(FilterViewModel);
  const meetingViewModel = useViewModel(MeetingViewModel);
  const navigate = useNavigate();

  const days = [];
  for (let day of calendarViewModel.filteredMeetings.keys())
    days.push(day);

  useEffect(() => {
    filterViewModel.getFilteredCalendar();
  }, []);
  const getFormatDate = (day: string) => {
    const date = new Date(day);
    return `${date.getDate()} ${shortMonths[date.getMonth()]}., ${date.getFullYear()}, ${weekDaysShort[date.getDay()]}`;
  };

  const getTimeInterval = (startDate: Date, endDate: Date) => {
    const start = startDate.toLocaleTimeString().slice(0, 5);
    const end = endDate.toLocaleTimeString().slice(0, 5);
    return `${start} - ${end}`;
  };

  const onClickMeeting = (meeting: IMeeting) => {
    navigate(PageRoutes.CALENDAR_PAGE);
    meetingViewModel.setIsOpenedFromFilterPage(true);
    meetingViewModel.initMeeting(meeting);
    meetingViewModel.setEditable(false);
  };

  return (
    <PageWrapper>
      <div className="header">
        <Link to={'/'} onClick={filterViewModel.resetFilters}>
          <BigBlueArrowLeft />
        </Link>
      </div>
      <div className="filtered-meetings">
        {!calendarViewModel.isLoading ? days.map(day => (
          !!calendarViewModel.filteredMeetings.get(day).length && (
            <div
              key={day.toLocaleString()}
              className='day-wrapper'
            >
              <div className="day">{getFormatDate(day as string)}</div>
              <div className="filtered-meetings-list">
                {calendarViewModel.filteredMeetings.get(day).map((meeting) => (
                  <div
                    className="filtered-meeting"
                    key={`meeting-${day.toLocaleString()}-${meeting.id}`}
                    onClick={() => onClickMeeting(meeting)}
                  >
                    <div className="info">
                      <div
                        className="circle"
                        style={{ backgroundColor: meeting.calendarColor }}
                      />
                      <div className="time">
                        {getTimeInterval(meeting.startDate, meeting.endDate)}
                      </div>
                    </div>
                    <div className="name">
                      {meeting.meetingName}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )
        ))
          : (
            <div className="loader-wrapper">
              <Loader />
            </div>
          )}
      </div>
    </PageWrapper >
  );
});
